///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Route } from '@angular/router';
import { PasswordResetFinishComponent } from './password-reset-finish.component';

export const passwordResetFinishRoute: Route = {
    path: 'reset/finish',
    component: PasswordResetFinishComponent,
    data: {
        authorities: [],
        pageTitle: 'global.menu.account.password'
    },
    title: 'Password'
};
